import type { NavItem, ProductCategory, SecondaryLink } from '../types';

// Static demo data used by the Storybook story and as the default for
// the organism props. Production data flows through the header tastic
// using CT's `treeCategories` already passed via page context.
//
// Includes a deep branch (Power & Ecotech → Batteries → Lithium → 18650)
// so the recursive renderer's depth handling is exercised in Storybook.

export const sampleMainNavItems: NavItem[] = [
  { label: 'Shop Products', href: '/category', hasMenu: true },
  { label: 'FAQ', href: '/faq' },
  { label: 'Articles', href: '/articles' },
  { label: 'Contact Us', href: '/contact' },
];

export const sampleSecondaryLinks: SecondaryLink[] = [
  { label: 'Store Finder', href: '/store-finder' },
  { label: 'Maker Hub', href: '/maker-hub' },
  { label: 'Projects', href: '/projects' },
  { label: 'Articles', href: '/articles' },
];

export const sampleProductCategories: ProductCategory[] = [
  {
    label: 'Test & Tools',
    href: '/category/test-tools',
    children: [
      {
        label: 'Multimeters',
        href: '/category/test-tools/multimeters',
        children: [
          { label: 'Digital Multimeters', href: '/category/test-tools/multimeters/digital' },
          { label: 'Clampmeters', href: '/category/test-tools/multimeters/clampmeters' },
          { label: 'Analog Multimeters', href: '/category/test-tools/multimeters/analog' },
          { label: 'Test Leads', href: '/category/test-tools/multimeters/test-leads' },
        ],
      },
      {
        label: 'Soldering',
        href: '/category/test-tools/soldering',
        children: [
          { label: 'Soldering Irons', href: '/category/test-tools/soldering/irons' },
          { label: 'Soldering Accessories', href: '/category/test-tools/soldering/accessories' },
        ],
      },
      { label: '3D Printing', href: '/category/test-tools/3d-printing' },
    ],
  },
  {
    label: 'Cables & Connectors',
    href: '/category/cables-connectors',
    children: [
      {
        label: 'Audio Cables',
        href: '/category/cables-connectors/audio-cables',
        children: [
          { label: 'RCA Cables', href: '/category/cables-connectors/audio-cables/rca' },
          { label: '3.5mm Cables', href: '/category/cables-connectors/audio-cables/3-5mm' },
        ],
      },
      {
        label: 'USB Cables',
        href: '/category/cables-connectors/usb-cables',
        children: [
          { label: 'USB-A Cables', href: '/category/cables-connectors/usb-cables/usb-a' },
          { label: 'USB-C Cables', href: '/category/cables-connectors/usb-cables/usb-c' },
        ],
      },
    ],
  },
  {
    label: 'Power & Ecotech',
    href: '/category/power-ecotech',
    children: [
      {
        label: 'Batteries',
        href: '/category/power-ecotech/batteries',
        children: [
          { label: 'AA Batteries', href: '/category/power-ecotech/batteries/aa' },
          {
            label: 'Lithium',
            href: '/category/power-ecotech/batteries/lithium',
            children: [
              { label: '18650', href: '/category/power-ecotech/batteries/lithium/18650' },
              { label: 'CR123A', href: '/category/power-ecotech/batteries/lithium/cr123a' },
            ],
          },
          { label: 'Rechargeable', href: '/category/power-ecotech/batteries/rechargeable' },
        ],
      },
    ],
  },
];
